@if (showPopup) {
  <div
    class="input-shield"
    htcTrapFocus
    role="dialog"
    attr.aria-labelledby="{{ 'PROFILE_MENU.CONTACT_SUPPORT' | translate }}">
    <div class="popup" [attr.aria-hidden]="!showPopup">
      <div class="header">
        <svg-icon
          src="assets/button-icons/support.svg"
          attr.alt="{{
            'PROFILE_MENU.CONTACT_SUPPORT' | translate
          }}"></svg-icon>
        <span>{{ 'PROFILE_MENU.CONTACT_SUPPORT' | translate }}</span>
        <htc-button-with-icon
          data-testid="htc-contact-support-close-button"
          classes="btn btn-no-border btn-no-bkgd btn-contact-support-close interactive-cmp"
          imagePath="/assets/button-icons/cancel-x.svg"
          btnText=""
          attr.aria-label="{{
            'PROFILE_MENU.CLOSE_SUPPORT_ARIA_LABEL' | translate
          }}"
          (btnClicked)="closePopup()"></htc-button-with-icon>
      </div>
      <div class="content-container">
        <div class="contact-block contact-block-icon contact-block-icon-action">
          <span>
            <a
              data-testid="htc-contact-support-email-link"
              class="interactive-cmp"
              [href]="supportUrl"
              target="_blank"
              rel="noopener noreferrer"
              title="{{ 'PROFILE_MENU.EMAIL_TITLE' | translate }}"
              htcAudioClick
              [audioType]="clickType"
              [descriptor]="clickDescriptor"
              >{{ supportUrl }}
            </a>
          </span>
          <span>
            <svg-icon
              src="assets/button-icons/mail.svg"
              attr.alt="{{ 'PROFILE_MENU.EMAIL_ALT' | translate }}"></svg-icon>
            <a
              data-testid="htc-contact-support-email-link"
              class="interactive-cmp"
              href="mailto:{{ supportEmail }}"
              title="{{ 'PROFILE_MENU.EMAIL_TITLE' | translate }}"
              htcAudioClick
              [audioType]="clickType"
              [descriptor]="clickDescriptor"
              >{{ supportEmail }}
            </a>
          </span>
        </div>
        <div class="contact-block-bottom">
          <span class="versions"
            >{{ 'PROFILE_MENU.APP_VERSION' | translate }} {{ version }}
          </span>
        </div>
      </div>
    </div>
  </div>
}
